<template>
  <div>
    <a-collapse v-model="activeKey" expand-icon-position="right">
      <a-collapse-panel key="1" style="border-left: 5px solid #FF577F;">
        <span slot="header">
          <h6 class="font-web mt-0 mb-0 font-weight-bold">
            ข้อกำหนดการขอทำงานล่วงเวลา
          </h6>
          <p class="font-web mt-0 mb-0 text-muted">
            ตามประกาศจาก งานทรัพยากรบุคคลวิทยาลัยนานาชาติ
          </p>
        </span>
        <a-list item-layout="horizontal">
          <a-list-item>
            <a-list-item-meta>
              <h6 class="mt-5 mb-5 font-web font-weight-bold" slot="title">
                <span class="label-text-t">การปัดเศษชั่วโมง</span>
              </h6>
              <a-avatar slot="avatar" :size="30" icon="notification" />
              <div slot="description">
                <!--  
                  <h6 class="mt-10 mb-5 font-web">กรณีอยู่ไม่ถึง 1 ชั่วโมงแรก</h6>
                  <ul>
                    <li>
                      <p class="mt-0 mb-0">การอยู่ทำงานล่วงเวลา</p>
                      <p class="mt-0 mb-0">
                        <span class="font-web text-danger"
                          >ตั้งแต่นาทีที่ 31 - 59
                          คิดเป็นอยู่ทำงานล่วงเวลาเป็นครึ่งชั่วโมง ( 0.5 )</span
                        >
                        เช่น 17.00 – 17.55
                      </p>
                    </li>
                  </ul>
                -->
                <h6 class="mt-0 mb-5 font-web">
                  กรณีอยู่ตั้งแต่ 1 ชั่วโมงเป็นต้นไป
                </h6>
                <ul>
                  <li>
                    <p class="mt-0 mb-0">การอยู่ทำงานล่วงเวลา</p>
                    <p class="mt-0 mb-0">
                      <span class="font-web text-danger">ตั้งแต่นาทีที่ 15 - 45
                        คิดการอยู่ทำงานล่วงเวลาเป็นครึ่งชั่วโมง ( 0.5 )</span>
                      เช่น 17.00 - 18.45 = 1.5 ชั่วโมง
                    </p>
                  </li>
                  <li>
                    <p class="mt-0 mb-0">การอยู่ทำงานล่วงเวลา</p>
                    <p class="mt-0 mb-0">
                      <span class="font-web text-danger">ตั้งแต่นาทีที่ 46 - 59
                        คิดการอยู่ทำงานล่วงเวลาเป็นหนึ่งชั่วโมง ( 1.0 )</span>
                      เช่น 17.00 - 18.46 = 2.0 ชั่วโมง
                    </p>
                  </li>
                </ul>
              </div>
            </a-list-item-meta>
          </a-list-item>
          <a-list-item>
            <a-list-item-meta>
              <h6 class="mt-0 mb-0 font-web" slot="title">
                <span class="label-text-t">การคำนวณชั่วโมง</span>
              </h6>
              <a-avatar slot="avatar" :size="30" icon="notification" />
              <div slot="description">
                <h6 class="mt-10 mb-5 font-web">กรณีวันมาปฏิบัติงานปกติ</h6>
                <ul>
                  <li>
                    <p class="mt-0 mb-0">
                      คิดเป็นจำนวนชั่วโมง
                      <span class="font-web text-danger font-weight-bold">คูณด้วย 1.5 เท่า ( ชั่วโมง x 1.5 )</span>
                    </p>
                    <p class="mt-0 mb-0">
                      EX. ขอทำงานล่วงเวลาตั้งแต่ 17.00 - 20.00 คิดเป็น 1.5
                      เท่าจำนวน 3 ชั่วโมง
                    </p>
                  </li>
                </ul>
                <h6 class="mt-0 mb-5 font-web">
                  กรณีวันหยุดนักขัตฤกษ์ และ เสาร์-อาทิตย์
                </h6>
                <ul>
                  <li>
                    <span class="font-web text-danger font-weight-bold">ชั่วโมงที่ 1 – 4 คิดเป็น 1 เท่า</span>
                    ( 08.00 – 12.00 ) จำนวน 4 ชั่วโมง
                  </li>
                  <li>
                    <span class="font-web text-danger font-weight-bold">ชั่วโมงที่ 5
                      ไม่นำมาคำนวณในการทำงานล่วงเวลา</span>
                    ( 12.00 – 13.00 )
                  </li>
                  <li>
                    <span class="font-web text-danger font-weight-bold">ชั่วโมงที่ 6 – 9 คิดเป็น 1 เท่า</span>
                    ( 13.00 – 17.00 ) จำนวน 4 ชั่วโมง
                  </li>
                  <li>
                    <span class="font-web text-danger font-weight-bold">ชั่วโมงที่ 10 คิดเป็น 3 เท่า</span>
                    ( 17.00 – 20.00 ) จำนวน 3 ชั่วโมง
                  </li>
                </ul>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
        <div class="text-center">
          <a-button style="font-size:16px;" size="small" type="link" class="mt-0 mb-5 font-web" @click="
            () => {
              activeKey = [];
            }
          ">
            <u>&nbsp;ดูน้อยลง&nbsp;</u>
          </a-button>
        </div>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>
<script>
export default {
  data() {
    return {
      text: `A dog is a type of domesticated animal.Known for its loyalty and faithfulness,it can be found as a welcome guest in many households across the world.`,
      activeKey: ["1"],
    };
  },
  watch: {
    activeKey(key) {
    },
  },
};
</script>

<style scoped>
.label-text-t {
  background-color: #98a8f8;
  /* color:#ffffff; */
  padding: 5px;
  border-left: 5px solid #5837d0;
  border-radius: 5px;
}
</style>